var _path, _path2, _rect, _path3, _line, _path4, _path5, _rect2, _polygon, _path6, _path7, _path8, _path9, _line2, _path0, _line3, _path1, _path10, _path11, _path12, _line4, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _path20, _path21, _path22, _path23, _path24, _ellipse, _ellipse2, _path25, _path26, _path27, _path28, _path29, _path30, _path31, _line5, _line6, _line7;
const _excluded = ["svgRef", "title"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import React from "react";
const SvgMercurioError404 = _ref => {
  let {
      svgRef,
      title
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 346,
    height: 288,
    viewBox: "0 0 346 288",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M322.47,39.4c-17.7-20-46.12-26.9-72.85-28.07-10.83-.46-21.89-.15-32.17,3.28C196.7,21.55,182.15,40,163.74,51.79,128.19,74.63,80.17,71.93,46,96.78a98.57,98.57,0,0,0-22.53,23.31c-24.9,35.68-26.85,85.11-7.84,124.25a136.5,136.5,0,0,0,22.23,32.5h246c22.1-22.37,37.45-51,47-81.6a280.48,280.48,0,0,0,12.28-78.39C343.51,89.5,340.51,59.91,322.47,39.4Z",
    fill: "#c6f1e1"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M130.07,276.77h97.48c-1.79-7.2-3.91-15-6.45-23.39l-14.19-22.27-60.82,3-17,23.55S130.36,257.24,130.07,276.77Z",
    fill: "#262626"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 228.08,
    y: 36.96,
    width: 101.92,
    height: 41.31,
    rx: 3.39,
    fill: "#fafafa",
    stroke: "#262626",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.5
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M280,72.19a12.65,12.65,0,0,1,0-25.29,12.65,12.65,0,0,1,0,25.29Zm0-21.72a9.08,9.08,0,0,0-6.64,15.26A9,9,0,0,0,280,68.62a9.08,9.08,0,1,0,0-18.15Z",
    fill: "#01ffc8"
  })), _line || (_line = /*#__PURE__*/React.createElement("line", {
    x1: 287.52,
    y1: 52.63,
    x2: 273.21,
    y2: 66.95,
    fill: "#01ffc8"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M273.21,68.73a1.75,1.75,0,0,1-1.26-.52,1.77,1.77,0,0,1,0-2.52l14.31-14.32a1.78,1.78,0,1,1,2.52,2.52L274.47,68.21A1.78,1.78,0,0,1,273.21,68.73Z",
    fill: "#01ffc8"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M326.87,36.5H231.21a3.13,3.13,0,0,0-3.13,3.13v2.61H330V39.63A3.13,3.13,0,0,0,326.87,36.5Z",
    fill: "#fafafa",
    stroke: "#262626",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.5
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 279.12,
    y: 177.12,
    width: 55.88,
    height: 55.88,
    rx: 3.51,
    fill: "#fafafa",
    stroke: "#262626",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.5
  })), _polygon || (_polygon = /*#__PURE__*/React.createElement("polygon", {
    points: "307.06 187.92 287.27 222.21 326.86 222.21 307.06 187.92",
    fill: "#fafafa",
    stroke: "#262626",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.5
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M309.21,212.75a1.79,1.79,0,0,1,.54,1.31,1.86,1.86,0,0,1-1.88,1.88,1.78,1.78,0,0,1-1.31-.55,1.83,1.83,0,0,1-.55-1.33,1.8,1.8,0,0,1,.55-1.31,1.78,1.78,0,0,1,1.31-.55A1.81,1.81,0,0,1,309.21,212.75Zm.4-11.48-.41,9h-2.65l-.41-9Z",
    fill: "#01ffc8"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M85.46,55.21,96.14,44.53A2.95,2.95,0,1,0,92,40.36L81.29,51,70.62,40.36a2.95,2.95,0,1,0-4.17,4.17L77.13,55.21,66.45,65.88a2.95,2.95,0,0,0,4.17,4.17L81.29,59.37,92,70.05a2.95,2.95,0,1,0,4.17-4.17Z",
    fill: "#01ffc8"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M212.91,81.93a4.1,4.1,0,0,0-1.36-6.37l-.05,0a23.18,23.18,0,0,1-10.3-9.15A17.87,17.87,0,0,1,198.6,59C197.25,51,175.18,21.4,144,42.82c-1.89,1.3.79,1.56.54,3.86,0,0-11.19,19.34-15.46,22.38-5.6,4-9.36,9.84-11.74,14.81a10.86,10.86,0,0,0,5.43,14.65c9.8,4.3,28.37,11.53,56.77,6.32C179.7,104.8,199.11,98.09,212.91,81.93Z",
    fill: "#262626"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M198.12,87.33c-2.57,10-12.74-1.28-22,3.39L132.73,87c-3.87-4.73-4.38-21.56,1.54-33.95,3-6.17,5.58-13,11.56-16.27a35.67,35.67,0,0,1,15-4.77c10.08-.3,19.21,1.57,27.1,7.93,8.86,7.12,11,18.78,13.11,29.95C202.35,76.85,199.8,80.48,198.12,87.33Z",
    fill: "#262626"
  })), _line2 || (_line2 = /*#__PURE__*/React.createElement("line", {
    x1: 168.85,
    y1: 266.39,
    x2: 170.18,
    y2: 277.11,
    fill: "none",
    stroke: "#fafafa",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.5
  })), _path0 || (_path0 = /*#__PURE__*/React.createElement("path", {
    d: "M75.35,141.19c-.71-1.23-5.5-10.89-9-13.92-3.18-4.9-10-8.61-15.08-10l-9-2.45a4,4,0,0,0-4.8,2.24c-.89,2.18.71,4,2.63,4.79l8,2.31c-1.83,1.08-6.13,3.15-9.81,1.34-.64-1.86-1.36-4-1.71-5.19-.67-2.33-2.09-3.63-3.87-3.58a2,2,0,0,0-1.31.57,2.07,2.07,0,0,0-.63,1.93l1.81,9.3-1.16-.83c-.44-.84-3.53-6.56-4.1-7.88l-.14-.32c-.56-1.36-1.88-4.52-4.24-5.31a4,4,0,0,0-3.33.49h0l-.05,0-.39.23,1.25,2.7-.74-1c-.06-.09-1.41-2.21-3.41-2.43a3.6,3.6,0,0,0-3,1.24l-.28.29,7.65,11.91h0v0l2.33,3.63.05,0a3,3,0,0,0,1.43,1.06l32.68,11.17.87,5.3,17.74-6.56Z",
    fill: "#fafafa"
  })), _line3 || (_line3 = /*#__PURE__*/React.createElement("line", {
    x1: 95.17,
    y1: 197.13,
    x2: 90.15,
    y2: 181.08,
    fill: "#fafafa",
    stroke: "#262626",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.5
  })), _path1 || (_path1 = /*#__PURE__*/React.createElement("path", {
    d: "M23.43,130.89a2.49,2.49,0,0,0,1.27,1l33,11.26.83,5-.15-.88,0,.26L64,179.82l3.45,19.8C68.55,206.05,69.3,213,72,219c1.61,3.57,4.26,6.84,7.87,8.36,4.46,1.88,9.67.83,14-1.29a35.27,35.27,0,0,0,5-3c8.61-6.21,15-15.68,21.72-23.74l13-15.47L99.21,164.36l-8.66,17.88-10-27.72A102.38,102.38,0,0,0,66.32,128l-.43-.56.1.15c-3-4.59-9.52-8.37-14.82-9.82l-9-2.45A3.53,3.53,0,0,0,38,117.24c-.74,1.82.59,3.41,2.31,4.12L49.38,124s-6.14,4.52-11.27,2",
    fill: "#fafafa",
    stroke: "#262626",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.56
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M50.23,132.74l-11-3.41s-2.28-6.33-3-8.9c-.64-2.25-2-3.25-3.37-3.21a1.54,1.54,0,0,0-1,.43h0a1.59,1.59,0,0,0-.47,1.47l2,10.55L31.12,128s-3.55-6.55-4.18-8-2.75-7.43-7-4.89l2.91,6.31-3.47-4.49s-2.6-4.14-5.61-1.11l9.77,15.23",
    fill: "none",
    stroke: "#262626",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.56
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M28.23,132.6a22,22,0,0,1-1.37-2.19c-.83-1.57-1.64-3.89-2.79-6.36s-2.13-4.73-2.88-6.35c-.38-.8-.69-1.45-.92-1.9a3.14,3.14,0,0,0-.38-.68",
    fill: "#fafafa",
    stroke: "#262626",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.56
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M261.8,136.28l17.74,6.56.87-5.3,32.68-11.17a2.94,2.94,0,0,0,1.42-1.06l.06,0,2.32-3.63v0h0l7.65-11.91-.28-.29a3.6,3.6,0,0,0-3-1.24c-2,.22-3.35,2.34-3.41,2.43l-.74,1,1.25-2.7-.39-.23-.05,0h0a4,4,0,0,0-3.33-.49c-2.36.79-3.68,4-4.24,5.31l-.14.32c-.57,1.32-3.66,7-4.1,7.88l-1.16.83,1.81-9.3a2.07,2.07,0,0,0-.63-1.93,2,2,0,0,0-1.31-.57c-1.78,0-3.21,1.25-3.87,3.58-.35,1.22-1.07,3.33-1.71,5.19-3.68,1.81-8-.26-9.81-1.34l8-2.31c1.92-.79,3.52-2.61,2.63-4.79a4,4,0,0,0-4.8-2.24l-9,2.45c-5,1.38-11.9,5.09-15.09,10-3.45,3-8.24,12.69-8.95,13.92Z",
    fill: "#fafafa"
  })), _line4 || (_line4 = /*#__PURE__*/React.createElement("line", {
    x1: 242.47,
    y1: 191.13,
    x2: 247.49,
    y2: 175.08,
    fill: "#fafafa",
    stroke: "#262626",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.5
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M314.21,124.89a2.49,2.49,0,0,1-1.27,1l-33,11.26-.83,5,.15-.88,0,.26-5.61,32.3-3.45,19.8c-1.11,6.43-1.86,13.38-4.53,19.34-1.61,3.57-4.26,6.84-7.87,8.36-4.46,1.88-9.67.83-14-1.29a35.27,35.27,0,0,1-5-3c-8.61-6.21-14.95-15.68-21.72-23.74l-13-15.47,34.34-19.46,8.66,17.88,10-27.72A102.38,102.38,0,0,1,271.32,122l.43-.56-.1.15c3-4.59,9.52-8.37,14.82-9.82l9-2.45a3.53,3.53,0,0,1,4.21,1.95c.74,1.82-.59,3.41-2.31,4.12L288.26,118s6.14,4.52,11.27,2",
    fill: "#fafafa",
    stroke: "#262626",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.56
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M287.41,126.74l11-3.41s2.28-6.33,3-8.9c.64-2.25,2-3.25,3.37-3.21a1.54,1.54,0,0,1,1,.43h0a1.59,1.59,0,0,1,.47,1.47l-2.05,10.55,2.28-1.65s3.55-6.55,4.18-8,2.75-7.43,7.05-4.89l-2.91,6.31,3.47-4.49s2.6-4.14,5.61-1.11l-9.77,15.23",
    fill: "none",
    stroke: "#262626",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.56
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M309.41,126.6a20.46,20.46,0,0,0,1.36-2.19c.84-1.57,1.65-3.89,2.8-6.36s2.13-4.73,2.88-6.35c.38-.8.69-1.45.92-1.9a3.14,3.14,0,0,1,.38-.68",
    fill: "#fafafa",
    stroke: "#262626",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.56
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M107.59,136.26a37.46,37.46,0,0,1,2.57-4.8c.37-.54.76-1.08,1.18-1.58a18.07,18.07,0,0,1,9.12-5.68,22.4,22.4,0,0,1,22.76,7.63,17.73,17.73,0,0,1,2.73,4.9,17.48,17.48,0,0,1,1,5.69,30,30,0,0,1-1,6.12l-7.8,38.73L91.29,167.59l5-9.46c2.35-4.47,4.72-8.92,7-13.4,1.18-2.26,2.33-4.53,3.47-6.81C107.06,137.37,107.33,136.82,107.59,136.26Z",
    fill: "#34806b",
    stroke: "#262626",
    strokeMiterlimit: 10,
    strokeWidth: 1.5
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "M241.71,158.43l-18.85-27.57c-6-10.11-46-10.11-46-10.11l-38.5,2.2-12,.52s-26.32,57,3.83,140.6l91.64-6.22L208,187.27Z",
    fill: "#34806b",
    stroke: "#262626",
    strokeMiterlimit: 10,
    strokeWidth: 1.5
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    d: "M174.11,90.25c-5.86-1.19-10.49-.15-16.12.54-1.39.17-6.71-.22-8.24-.19l-.44-.66c0,.21.06.46.08.68-.08,0-.06,0,0,.07,1.26,10.58,4.63,25.89-5.3,32.21,21.26,22.42,31.06,6.25,35.58-1.49C175.15,107.68,171.6,104.84,174.11,90.25Z",
    fill: "#fafafa",
    stroke: "#262626",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.5
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    d: "M174.11,90.82c-5.86-1.19-10.49-.15-16.12.53-1.39.17-6.71-.21-8.24-.19l-.44-.65c0,.21.06.45.08.67-.08,0-.06,0,0,.08.88,7.39,2.79,17.08.47,24.41,8.95.55,17.33-5,23.69-12.36A39.45,39.45,0,0,1,174.11,90.82Z",
    fill: "#262626"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    d: "M138.32,60.21C136,74.59,128.57,99.59,146,107.93c18.83,9.07,37.09-12.7,42-28.75,5.2-17-.12-34.54-20.26-35.72-10.53-.54-29,3.34-29.16,17",
    fill: "#fafafa",
    stroke: "#262626",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.5
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    d: "M153.31,78.77s.94,9-1.71,13.93c0,0,3.2,2.83,6.09.25",
    fill: "none",
    stroke: "#262626",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.5
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    d: "M171.06,72.8a8.42,8.42,0,0,0-10.28-.15",
    fill: "none",
    stroke: "#262626",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.5
  })), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    d: "M149.62,75.85a8.43,8.43,0,0,0-10.29-.15",
    fill: "none",
    stroke: "#262626",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.5
  })), _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    d: "M157.52,99.93s4.63-3,7.71-.13",
    fill: "#fafafa",
    stroke: "#262626",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.5
  })), _ellipse || (_ellipse = /*#__PURE__*/React.createElement("ellipse", {
    cx: 165.57,
    cy: 80.25,
    rx: 1.4,
    ry: 2.81,
    transform: "translate(-0.24 0.5) rotate(-0.17)",
    fill: "#262626"
  })), _ellipse2 || (_ellipse2 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 144.93,
    cy: 80.31,
    rx: 1.4,
    ry: 2.81,
    transform: "translate(-0.24 0.44) rotate(-0.17)",
    fill: "#262626"
  })), _path25 || (_path25 = /*#__PURE__*/React.createElement("path", {
    d: "M184.06,76.76a7.12,7.12,0,0,1,3.9-2.28,4.16,4.16,0,0,1,1.1-.19,4.53,4.53,0,0,1,2.6,1,5.87,5.87,0,0,1,1.82,1.86,4.78,4.78,0,0,1,.34,3.43,6.25,6.25,0,0,1-3.56,4.32,5.23,5.23,0,0,1-5.43-.87",
    fill: "#fafafa",
    stroke: "#262626",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.5
  })), _path26 || (_path26 = /*#__PURE__*/React.createElement("path", {
    d: "M158.92,43.75s-4.59,33,33.75,30.06l1.5-10L183.44,45.73l-17.5-7.34Z",
    fill: "none",
    stroke: "#262626",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.5
  })), _path27 || (_path27 = /*#__PURE__*/React.createElement("path", {
    d: "M155.78,41s5.08,33.88,33.87,32.75l4.52-13L183.44,42.73l-17.5-7.34Z",
    fill: "#262626"
  })), _path28 || (_path28 = /*#__PURE__*/React.createElement("path", {
    d: "M135.45,68.14s18.63-5.65,26-19.77l-.56-5.08S154.65,41,154.08,41,140.53,46.12,140,46.12s-4.52,13.55-4.52,14.11Z",
    fill: "#262626"
  })), _path29 || (_path29 = /*#__PURE__*/React.createElement("path", {
    d: "M322.47,39.4c-17.7-20-46.12-26.9-72.85-28.07-10.83-.46-21.89-.15-32.17,3.28C204.15,19.06,194.85,26.88,184,36c-2.83-3.25-6.6-4.4-7-4-1,1-15-3-15-3l-15,3s-15,15-16,17c-.87,1.75-9,15.88-10.54,20.35C94.53,76.4,44.52,66.35,23,82c-8.75,6.47,3.17,13-3,22C-4.9,139.68-3.38,205.2,15.63,244.34a136.5,136.5,0,0,0,22.23,32.5h246c22.1-22.37,37.45-51,47-81.6a280.48,280.48,0,0,0,12.28-78.39C343.51,89.5,340.51,59.91,322.47,39.4Z",
    fill: "none"
  })), _path30 || (_path30 = /*#__PURE__*/React.createElement("path", {
    d: "M5.69,276.94c0,.09,68.82.17,153.7.17s153.71-.08,153.71-.17-68.8-.17-153.71-.17S5.69,276.84,5.69,276.94Z",
    fill: "#fafafa",
    stroke: "#262626",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.5
  })), _path31 || (_path31 = /*#__PURE__*/React.createElement("path", {
    d: "M63.78,256.06H21.44a5.68,5.68,0,0,1-5.68-5.68h0a5.67,5.67,0,0,1,5.68-5.67H63.78a5.67,5.67,0,0,1,5.68,5.67h0A5.68,5.68,0,0,1,63.78,256.06Z",
    fill: "#01ffc8"
  })), _line5 || (_line5 = /*#__PURE__*/React.createElement("line", {
    x1: 200.06,
    y1: 174.61,
    x2: 207.96,
    y2: 187.27,
    fill: "#34806b",
    stroke: "#262626",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.5
  })), _line6 || (_line6 = /*#__PURE__*/React.createElement("line", {
    x1: 90.55,
    y1: 182.24,
    x2: 94.63,
    y2: 192.68,
    fill: "none",
    stroke: "#262626",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.56
  })), _line7 || (_line7 = /*#__PURE__*/React.createElement("line", {
    x1: 247.49,
    y1: 175.08,
    x2: 243.41,
    y2: 185.52,
    fill: "none",
    stroke: "#262626",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.56
  })));
};
const ForwardRef = /*#__PURE__*/React.forwardRef((props, ref) => /*#__PURE__*/React.createElement(SvgMercurioError404, _extends({
  svgRef: ref
}, props)));
export default __webpack_public_path__ + "static/media/mercurio_error_404.e867aeb0.svg";
export { ForwardRef as ReactComponent };